import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import { toast, loading } from '@/shared/utils/UIHelper'
import inputnewboll from '@/views/private/realestate/ocurrence/components/addocurrence/components/inputnewboll.vue'

export default {
  name: 'ratingCustomer',
  mixins: [ActionsForm, ExpenseMixin],
  props:
  {
    dataDetails: {
      type: Object,
      default: {}
    },
    statusOcorencia: {
      type: Number,
      default: 0
    }
  },
  components: {
    HeadDetailsGama,
    inputnewboll
  },
  data () {
    return {
      head: ['Descrição', 'Ótimo', 'Bom', 'Regular', 'Ruim'],
      status: '',
      flDisable: false,
      problemaRaizArray: [],
      dataAllPatologia: [],
      avaliacaoMatriz: [
        [false, false, false, false],
        [false, false, false, false],
        [false, false, false, false],
        [false, false, false, false]
      ],
      otimo: false,
      bom: false,
      regular: false,
      ruim: false,
      editarAvaliacao: false
    }
  },
  watch: {
    statusOcorencia (newvalue) {
      this.flDisable = newvalue >= 3 || newvalue < 0
      this.editarAvaliacao = !this.flDisable
    }
  },
  mounted () {
    this.GetProblemaRaiz()
    this.GetAllPatologia()
    this.flDisable = this.statusOcorencia >= 3 || this.statusOcorencia < 0
    this.getVistoriaById(this.dataDetails)
    this.atualizaAvalicaoMatriz(0, this.dataDetails.qualidade, true)
    this.atualizaAvalicaoMatriz(1, this.dataDetails.tempoResposta, true)
    this.atualizaAvalicaoMatriz(2, this.dataDetails.comportamento, true)
    this.atualizaAvalicaoMatriz(3, this.dataDetails.organizacao, true)
  },
  methods: {
    getVistoriaById (e) {
      let id = e.id
      console.log(e)
      OcurrenceRepository.GetVistoriaById(id)
        .then((res) => {
          this.dataDetails = res.data
        })
        .catch(() => {})
    },
    GetAllPatologia () {
      loading.push()
      OcurrenceRepository.GetPatologia()
        .then((Response) => {
          loading.pop()
          this.dataAllPatologia = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    onSubmit (e) {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return
        }
        let sendData = {}
        var lstdespesas = []
        this.avaliacaoMatriz.forEach(lista => {
          let valorConvertidoParaEnum = 0
          let i = 0
          while (!lista[i]) {
            valorConvertidoParaEnum++
            i++
          }
          console.log(valorConvertidoParaEnum)
          lstdespesas.push(valorConvertidoParaEnum)
        })
        this.dataDetails.qualidade = lstdespesas[0]
        this.dataDetails.tempoResposta = lstdespesas[1]
        this.dataDetails.comportamento = lstdespesas[2]
        this.dataDetails.organizacao = lstdespesas[3]
        Object.assign(sendData, this.dataDetails)

        OcurrenceRepository.PutVistoria(sendData)
          .then(res => {
            if (res.status === 200) {
              toast.success(`Alterações salvas com sucesso`)
              this.$emit('updateView', false)
              loading.pop()
            }
          })
          .catch(() => {
            toast.error(`Erro ao salvar mudanças`)
            loading.pop()
          })
      })
    },
    GetProblemaRaiz () {
      loading.push()
      OcurrenceRepository.GetProblemaRaiz()
        .then(Response => {
          this.problemaRaizArray = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    atualizaAvalicaoMatriz (linha, coluna, mounted = false) {
      if (this.editarAvaliacao === true || mounted) {
        let novoArray = []
        for (let i = 0; i < this.avaliacaoMatriz[linha].length; i++) {
          if (i !== coluna) {
            novoArray.push(false)
          } else {
            novoArray.push(true)
          }
        }
        this.avaliacaoMatriz[linha] = novoArray
        this.$set(this.avaliacaoMatriz, linha, novoArray)
      } else {
        this.editarAvaliacao = false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/ratingCustomer/ratingCustomer.js